import { OrganizationsStudents } from "@/pages/contactpersonen/$organizationUserId/students/OrganizationStudents"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { organizationUserId } = useParams({
    from: "/beheer/contactpersonen/$organizationUserId",
  })

  return (
    <OrganizationsStudents organizationUserId={Number(organizationUserId)} />
  )
}
